export const types = {
  CLOSE: 'contacts/accountDetails/billingAddressesDrawer/CLOSE',
  OPEN: 'contacts/accountDetails/billingAddressesDrawer/OPEN',
};

export const billingAddressDrawer = {
  close: () => ({
    type: types.CLOSE,
  }),
  open: () => ({
    type: types.OPEN,
  }),
};
